import type { ICultureResources } from '../../models/resource.model';

import rawGtmLoader from './../inline-scripts/gtm-loader.script';

export const defaultResources: ICultureResources = {
    cssVars: {
        fontFamilyTitle: 'Oswald Variable',
        fontFamilyText: 'Roboto Flex Variable',
    },
    preloads: [
        {
            tag: 'link',
            location: 'head',
            attributes: {
                href: '/assets/fonts/roboto-flex/files/roboto-flex-latin-wght-normal.woff2',
                rel: 'preload',
                as: 'font',
                type: 'font/woff2',
                crossorigin: 'anonymous',
            },
        },
        {
            tag: 'link',
            location: 'head',
            attributes: {
                href: '/assets/fonts/oswald/files/oswald-latin-wght-normal.woff2',
                rel: 'preload',
                as: 'font',
                type: 'font/woff2',
                crossorigin: 'anonymous',
            },
        },
    ],
    styles: [
        {
            tag: 'link',
            location: 'head',
            persist: true,
            attributes: {
                href: '/assets/fonts/roboto-flex/index.css',
                rel: 'stylesheet',
            },
        },
        {
            tag: 'link',
            location: 'head',
            persist: true,
            attributes: {
                href: '/assets/fonts/oswald/index.css',
                rel: 'stylesheet',
            },
        },
    ],
    scripts: [
        {
            tag: 'script',
            location: 'head',
            textContent: rawGtmLoader,
            attributes: { type: 'text/javascript', id: 'gtm-loader-inline' },
        },
    ],
};
